import * as React from 'react';

const ChairSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 7c0-2.2 1.8-4 4-4s4 1.8 4 4v8H8V7zm10 10c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1v-1h12v1zm1-5h-1v3h-1V7c0-2.8-2.2-5-5-5S7 4.2 7 7v8H6v-3H4v1h1v4c0 1.1.9 2 2 2h1v3h1v-3h6v3h1v-3h1c1.1 0 2-.9 2-2v-4h1v-1h-1z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 10h1v1h-1zM9 10h1v1H9zM11.5 8h1v1h-1zM14 6h1v1h-1zM9 6h1v1H9zM11.5 12h1v1h-1z"
        />
    </svg>
);

ChairSvg.displayName = 'ChairSvg';
export default ChairSvg;
